
import { WorldCountry } from '../types';

export const indonesiaExpanded2: WorldCountry = {
  name: 'Indonesia',
  slug: 'indonesia',
  code: 'ID',
  population: 273523615,
  topCities: [
    { name: 'Jakarta', slug: 'jakarta', population: 10770487 },
    { name: 'Surabaya', slug: 'surabaya', population: 2874699 },
    { name: 'Medan', slug: 'medan', population: 2435252 },
    { name: 'Bandung', slug: 'bandung', population: 2444160 },
    { name: 'Bekasi', slug: 'bekasi', population: 2543676 },
    { name: 'Depok', slug: 'depok', population: 2056000 },
    { name: 'Tangerang', slug: 'tangerang', population: 2139891 },
    { name: 'Palembang', slug: 'palembang', population: 1668848 },
    { name: 'Semarang', slug: 'semarang', population: 1653524 },
    { name: 'Makassar', slug: 'makassar', population: 1423877 },
    
    // Expansión: 90 ciudades adicionales
    { name: 'South Tangerang', slug: 'south-tangerang', population: 1354350 },
    { name: 'Batam', slug: 'batam', population: 1196396 },
    { name: 'Bandar Lampung', slug: 'bandar-lampung', population: 1166066 },
    { name: 'Bogor', slug: 'bogor', population: 1043070 },
    { name: 'Pekanbaru', slug: 'pekanbaru', population: 983356 },
    { name: 'Padang', slug: 'padang', population: 909040 },
    { name: 'Malang', slug: 'malang', population: 887443 },
    { name: 'Denpasar', slug: 'denpasar', population: 897300 },
    { name: 'Samarinda', slug: 'samarinda', population: 842691 },
    { name: 'Tasikmalaya', slug: 'tasikmalaya', population: 716155 },
    { name: 'Banjarmasin', slug: 'banjarmasin', population: 675915 },
    { name: 'Pontianak', slug: 'pontianak', population: 658685 },
    { name: 'Cimahi', slug: 'cimahi', population: 568400 },
    { name: 'Balikpapan', slug: 'balikpapan', population: 688318 },
    { name: 'Jambi', slug: 'jambi', population: 606200 },
    { name: 'Surakarta', slug: 'surakarta', population: 522364 },
    { name: 'Mataram', slug: 'mataram', population: 441298 },
    { name: 'Yogyakarta', slug: 'yogyakarta', population: 422732 },
    { name: 'Kupang', slug: 'kupang', population: 442758 },
    { name: 'Bengkulu', slug: 'bengkulu', population: 373591 },
    { name: 'Manado', slug: 'manado', population: 451893 },
    { name: 'Jayapura', slug: 'jayapura', population: 398478 },
    { name: 'Palu', slug: 'palu', population: 373218 },
    { name: 'Ambon', slug: 'ambon', population: 355596 },
    { name: 'Kendari', slug: 'kendari', population: 345107 },
    { name: 'Ternate', slug: 'ternate', population: 224371 },
    { name: 'Sorong', slug: 'sorong', population: 254906 },
    { name: 'Banda Aceh', slug: 'banda-aceh', population: 254904 },
    { name: 'Tarakan', slug: 'tarakan', population: 251914 },
    { name: 'Gorontalo', slug: 'gorontalo', population: 201143 },
    { name: 'Palangka Raya', slug: 'palangka-raya', population: 293500 },
    { name: 'Mamuju', slug: 'mamuju', population: 85000 },
    { name: 'Bitung', slug: 'bitung', population: 225134 },
    { name: 'Tomohon', slug: 'tomohon', population: 100587 },
    { name: 'Kotamobagu', slug: 'kotamobagu', population: 123722 },
    { name: 'Tual', slug: 'tual', population: 75064 },
    { name: 'Tidore', slug: 'tidore', population: 114480 },
    { name: 'Bima', slug: 'bima', population: 165464 },
    { name: 'Sumbawa Besar', slug: 'sumbawa-besar', population: 68731 },
    { name: 'Dompu', slug: 'dompu', population: 67959 },
    { name: 'Raba', slug: 'raba', population: 65645 },
    { name: 'Ende', slug: 'ende', population: 71843 },
    { name: 'Maumere', slug: 'maumere', population: 85458 },
    { name: 'Ruteng', slug: 'ruteng', population: 55329 },
    { name: 'Bajawa', slug: 'bajawa', population: 63000 },
    { name: 'Labuan Bajo', slug: 'labuan-bajo', population: 45000 },
    { name: 'Atambua', slug: 'atambua', population: 65000 },
    { name: 'Kefamenanu', slug: 'kefamenanu', population: 45000 },
    { name: 'Soe', slug: 'soe', population: 55000 },
    { name: 'Waingapu', slug: 'waingapu', population: 65000 },
    { name: 'Waikabubak', slug: 'waikabubak', population: 45000 },
    { name: 'Tambolaka', slug: 'tambolaka', population: 35000 },
    { name: 'Praya', slug: 'praya', population: 75000 },
    { name: 'Selong', slug: 'selong', population: 55000 },
    { name: 'Gerung', slug: 'gerung', population: 45000 },
    { name: 'Tanjung', slug: 'tanjung', population: 35000 },
    { name: 'Lembar', slug: 'lembar', population: 25000 },
    { name: 'Singaraja', slug: 'singaraja', population: 150000 },
    { name: 'Tabanan', slug: 'tabanan', population: 120000 },
    { name: 'Gianyar', slug: 'gianyar', population: 85000 },
    { name: 'Klungkung', slug: 'klungkung', population: 55000 },
    { name: 'Bangli', slug: 'bangli', population: 45000 },
    { name: 'Karangasem', slug: 'karangasem', population: 65000 },
    { name: 'Jembrana', slug: 'jembrana', population: 45000 },
    { name: 'Buleleng', slug: 'buleleng', population: 75000 },
    { name: 'Sukawati', slug: 'sukawati', population: 35000 },
    { name: 'Ubud', slug: 'ubud', population: 45000 },
    { name: 'Sanur', slug: 'sanur', population: 25000 },
    { name: 'Kuta', slug: 'kuta', population: 35000 },
    { name: 'Canggu', slug: 'canggu', population: 15000 },
    { name: 'Nusa Dua', slug: 'nusa-dua', population: 25000 },
    { name: 'Seminyak', slug: 'seminyak', population: 20000 },
    { name: 'Lovina', slug: 'lovina', population: 15000 },
    { name: 'Amed', slug: 'amed', population: 10000 },
    { name: 'Candidasa', slug: 'candidasa', population: 8000 },
    { name: 'Padang Bai', slug: 'padang-bai', population: 12000 },
    { name: 'Pemuteran', slug: 'pemuteran', population: 5000 },
    { name: 'Munduk', slug: 'munduk', population: 3000 },
    { name: 'Bedugul', slug: 'bedugul', population: 8000 },
    { name: 'Jatiluwih', slug: 'jatiluwih', population: 5000 },
    { name: 'Sekumpul', slug: 'sekumpul', population: 3000 },
    { name: 'Toya Bungkah', slug: 'toya-bungkah', population: 5000 },
    { name: 'Penelokan', slug: 'penelokan', population: 8000 },
    { name: 'Besakih', slug: 'besakih', population: 5000 },
    { name: 'Sidemen', slug: 'sidemen', population: 8000 },
    { name: 'Tulamben', slug: 'tulamben', population: 5000 },
    { name: 'Seririt', slug: 'seririt', population: 12000 },
    { name: 'Tejakula', slug: 'tejakula', population: 8000 },
    { name: 'Kubutambahan', slug: 'kubutambahan', population: 10000 },
    { name: 'Sawan', slug: 'sawan', population: 15000 }
  ]
};
